import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';

@Injectable()
export class AlertMessager {
    static showingAlert: boolean;

    constructor(private alert: AlertController) { }

    async showError(title, message) {
        const error = this.alert.create({
            title: title,
            message: message,
            buttons: [
            {
                text: 'Dismiss',
                handler: () => {
                    // Do nothing
                }
            }]
        });

        AlertMessager.showingAlert = true;
        await error.present();

        error.onDidDismiss(() => {
            AlertMessager.showingAlert = false;
        });
    }

    async showConfirmation(title, message) {
        const error = this.alert.create({
            title: title,
            message: message,
            buttons: [
            {
                text: 'Ok',
                handler: () => {
                    // Do nothing
                }
            }]
        });
        error.present();

        AlertMessager.showingAlert = true;
        await error.present();

        error.onDidDismiss(() => {
            AlertMessager.showingAlert = false;
        });
    }

    async prompt(title, message, yesHandler, noHandler = null) {
        const prompt = this.alert.create({
            title: title,
            message: message,
            buttons: [
            {
                text: 'Yes',
                handler: yesHandler
            },
            {
                text: 'No',
                handler: noHandler == null ? () => {} : noHandler
            }]
        });

        AlertMessager.showingAlert = true;
        await prompt.present();

        prompt.onDidDismiss(() => {
            AlertMessager.showingAlert = false;
        });
    }
}


// WEBPACK FOOTER //
// ./src/lib/alertMessager.ts